import {
  msgActionStateSending,
  msgActionStateSent,
  TForm,
} from "@/components/dialog/types";
import { contrastColor, hexToRGB } from "@/utils/colors";
import {Icon} from "@/components/Icon.tsx";
import React from "react";
import { camelToSnakeObj, getSession } from "@/utils/utils";
import { constants } from "@/constants";

const Form = ({
  form,
  action,
  token,
  onChange,
  onAction,
  bgColor,
}: {
  form: TForm;
  action: string;
  token: string;
  onChange: any;
  onAction?: any;
  bgColor: string;
}) => {
  let rgb = hexToRGB(bgColor);
  let contastColor = contrastColor(rgb.r, rgb.g, rgb.b);

  const onSubmit = async (form: TForm) => {
    onChange(form);

    let body: any | null = {
      action: action,
      token: token,
      session: getSession(token),
      formFields: form.fields,
    };
    body = camelToSnakeObj(body);

    try {
      form.state = msgActionStateSending;
      let res = await fetch(`${constants.url.API_PREFIX}chat/data`, {
        method: "POST",
        body: JSON.stringify(body),
      });

      form.state = msgActionStateSent;
      onChange(form);
      if (onAction) {onAction()}
    } catch (e) {
    }
  };

  return (
    <div className="px-3 text-gray-800 pt-2 flex flex-col items-end">
      {form.fields?.map((field: any, i: number) => {
        return (
          <div key={i} className="w-full">
            <span className="text-sm" style={{ color: contastColor }}>
              {field.title}
            </span>
            <input
              value={field.value ? field.value : ""}
              onChange={(event) => {
                if (!form.fields) {
                  return;
                }
                for (let fidx = 0; fidx < form.fields.length; fidx++) {
                  if (form.fields[fidx].title === field.title) {
                    form.fields[fidx].value = event.target.value;
                    break;
                  }
                }
                onChange(form);
              }}
              className={
                "mb-3 w-full rounded border border-gray-200 outline-0 p-1.5"
              }
              type="text"
            />
          </div>
        );
      })}

      <div className="flex flex-row items-center mb-3">
        {form.state == msgActionStateSending && (
          <Icon
            icon="fluent:arrow-sync-24-regular"
            className="animate-spin mr-2"
            width="25"
            style={{ color: contastColor }}
          />
        )}
        {form.state == msgActionStateSent && (
          <Icon
            icon="fluent:checkmark-24-regular"
            className="mr-2"
            width="25"
            style={{ color: contastColor }}
          />
        )}
        <button
          type="button"
          className="relative rounded text-sm"
          style={{
            color: contastColor,
            borderColor: contastColor,
            borderWidth: "1px",
          }}
          onClick={() => {
            onSubmit(form);
          }}
        >
          <div
            className="absolute w-full h-full opacity-0 hover:opacity-20"
            style={{ backgroundColor: contastColor }}
          ></div>
          <div className="w-full h-full flex items-center px-3 py-1">Send</div>
        </button>
      </div>
    </div>
  );
};

export default Form;
